import { render, staticRenderFns } from "./CreateAcount.vue?vue&type=template&id=ce7cfe70&scoped=true"
import script from "./CreateAcount.vue?vue&type=script&lang=js"
export * from "./CreateAcount.vue?vue&type=script&lang=js"
import style0 from "./CreateAcount.vue?vue&type=style&index=0&id=ce7cfe70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7cfe70",
  null
  
)

export default component.exports